var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealEstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/house-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.3333 22.25H2.33325C2.19939 22.25 2.08325 22.1339 2.08325 22C2.08325 21.8661 2.19939 21.75 2.33325 21.75H22.3333C22.4671 21.75 22.5833 21.8661 22.5833 22C22.5833 22.1339 22.4671 22.25 22.3333 22.25Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.03553 21.4997L3.08345 9.97179V9.96971C3.08345 9.27527 3.40119 8.63068 3.95001 8.20473L3.95061 8.20426L10.9504 2.7544C10.9505 2.75437 10.9505 2.75434 10.9505 2.75431C10.9506 2.75429 10.9506 2.75427 10.9506 2.75425C11.7589 2.12575 12.8966 2.12369 13.7176 2.75526C13.7179 2.75547 13.7181 2.75568 13.7184 2.75589L20.714 8.19247C20.7144 8.19278 20.7148 8.19309 20.7152 8.1934C21.2564 8.62038 21.5835 9.28622 21.5835 9.96971V21.4997H21.0835V9.97972C21.0835 9.44503 20.8322 8.93242 20.4158 8.5993L20.4158 8.59926L20.4103 8.59493L13.4104 3.15505C12.7779 2.6631 11.8976 2.66722 11.2607 3.15181L11.2607 3.15179L11.2563 3.15521L4.25924 8.60294C4.25871 8.60335 4.25817 8.60375 4.25764 8.60416C3.83337 8.93025 3.58381 9.44683 3.58345 9.97858L3.58345 9.97764L4.08345 9.97972H3.58345L3.03553 21.4997ZM3.03553 21.4997H3.53552H3.03553Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.58325 21.25V21.75H8.08325H16.5833H17.0833V21.25V12.5C17.0833 11.8139 16.5194 11.25 15.8333 11.25H8.83325C8.14711 11.25 7.58325 11.8139 7.58325 12.5V21.25ZM17.3333 22.25H7.33325C7.19939 22.25 7.08325 22.1339 7.08325 22V12.5C7.08325 11.5361 7.86939 10.75 8.83325 10.75H15.8333C16.7971 10.75 17.5833 11.5361 17.5833 12.5V22C17.5833 22.1339 17.4671 22.25 17.3333 22.25Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3333 18C10.1994 18 10.0833 17.8839 10.0833 17.75V16.25C10.0833 16.1161 10.1994 16 10.3333 16C10.4671 16 10.5833 16.1161 10.5833 16.25V17.75C10.5833 17.8839 10.4671 18 10.3333 18Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.8333 7.75H10.8333C10.6994 7.75 10.5833 7.63386 10.5833 7.5C10.5833 7.36614 10.6994 7.25 10.8333 7.25H13.8333C13.9671 7.25 14.0833 7.36614 14.0833 7.5C14.0833 7.63386 13.9671 7.75 13.8333 7.75Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstate);
export default __webpack_public_path__ + "static/media/RealEstate.45ff9b332670b9f74618442fcb9ba614.svg";
export { ForwardRef as ReactComponent };